<template>
  <transition name="app-preview" appear>
    <div class="app-preview">
      <slot />
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'AppPreview',
    data: () => ({
      previewData: {

      }
    }),
    provide () {
      return {
        previewData: this.previewData
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  .app-preview {
    width: 40%;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    z-index: 2;
    background-color: #fff;
  }

  .app-preview-enter-active {
    opacity: .38;
    transform: translate3d(100%, 0, 0);
    transition: .4s $transition-default;
    transition-property: opacity, transform;
    will-change: opacity, transform;
  }

  .app-preview-enter-to {
    opacity: 1;
  }
</style>
